import React from 'react';
import SpreadReadingPage from './SpreadReadingPage';

const config = {
  pickerPage: 'career',
  path: '/career-tarot-reading/',
  spreadId: 'moneyCareer',
  cardCount: 3,
  tagline: 'Free Career Tarot Reading',
  metaTitle: 'Free Career Tarot Reading Online - Money & Work Spread | NowTarot AI',
  metaDescription:
    'Get a free career tarot reading online. Draw 3 cards to explore your work situation, obstacles, and the path to success. 100% free, no signup required.',
  metaKeywords:
    'career tarot reading, money tarot, free career tarot, job tarot reading, work tarot spread, finance tarot',
  heading: 'Career & Money Tarot Reading',
  blurb: 'Draw 3 cards for work and money.',
  intro:
    'Facing a career decision, a stalled job search, or money worries? This free career tarot reading uses a dedicated money-and-career spread: three cards revealing your current situation, the obstacles in your way, and guidance toward prosperity. 100% free, no signup required.',
  howItWorks:
    'Focus on your work or financial question, then shuffle the deck and pick three cards. The first card shows your current career and money circumstances, the second exposes the challenges blocking your progress, and the third offers guidance for growth and success.',
  deckHeading: 'Draw Your 3 Career Cards',
  contentSections: [
    {
      heading: 'What a Career Tarot Reading Can Reveal',
      items: [
        {
          title: 'Job Decisions',
          text: 'Weighing an offer, a career change, or a bold move like starting your own business? The cards can clarify what is really driving the decision and what obstacles — internal or external — stand between you and the outcome you want.',
        },
        {
          title: 'Workplace Dynamics',
          text: 'Tension with a boss, stalled promotions, or team conflict often show up clearly in a career spread. The obstacle card in particular tends to name the thing everyone at work is dancing around.',
        },
        {
          title: 'Money & Security',
          text: 'Questions about savings, debt, investments, and financial stability are classic tarot territory — the entire suit of Pentacles is devoted to material life. The guidance card points toward your most constructive next step.',
        },
      ],
    },
    {
      heading: 'Cards to Watch For in Career Readings',
      items: [
        {
          title: 'Ace of Pentacles & The Magician',
          text: 'Strong omens for new opportunities. The Ace of Pentacles signals a tangible offer or opening, while The Magician says you already have every tool you need to succeed.',
        },
        {
          title: 'King of Swords & Queen of Wands',
          text: 'Court cards often represent people or energies at work. The King of Swords brings sharp, fair-minded judgment — excellent for negotiations — while the Queen of Wands radiates confident, entrepreneurial leadership.',
        },
        {
          title: 'Ten of Wands & Four of Pentacles',
          text: "Warning lights. The Ten of Wands signals burnout from carrying too much alone, and the Four of Pentacles suggests playing it so safe with money or position that you're actually stuck.",
        },
      ],
    },
  ],
  faqHeading: 'Career Tarot FAQ',
  faq: [
    {
      question: 'How does a career tarot reading work?',
      answer:
        'You focus on your work or money question, then draw three cards from the 78-card tarot deck. The cards represent your current situation, the obstacles affecting your prosperity, and guidance toward growth and financial success.',
    },
    {
      question: 'Can tarot help me decide whether to take a job?',
      answer:
        'Tarot will not make the decision for you, but it can surface what you already sense — the risks, the hidden upsides, and the fears clouding your judgment. Many people find the "obstacles" card names exactly what has been holding them back.',
    },
    {
      question: 'What questions should I ask in a career reading?',
      answer:
        'Try questions like "What do I need to know about my career path?", "What is blocking my financial growth?", or "What energy should I bring to my job search?" For a quick yes-or-no answer like "Will I get the job?", try our Yes or No tarot reading.',
    },
    {
      question: 'Is this career tarot reading free?',
      answer:
        'Yes! This career tarot reading is 100% free with no signup or credit card required. Draw as many readings as you like. For deeper, personalized guidance, ask our AI tarot reader in chat.',
    },
  ],
  crossLinks: (
    <>
      Want more? Ask a <a href="/yes-or-no-tarot/" style={{ color: '#FFD700' }}>yes or no tarot</a> question about your career,
      explore <a href="/tarot-card-meanings/" style={{ color: '#FFD700' }}>tarot card meanings</a>, or go deep with
      the <a href="/celtic-cross-tarot/" style={{ color: '#FFD700' }}>10-card Celtic Cross</a> — all free, no signup required.
    </>
  ),
};

const CareerTarot = () => <SpreadReadingPage config={config} />;

export default CareerTarot;
